var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"ma-0 ml-2",attrs:{"color":_vm.colorByInterval}},on),[_vm._v("\n      "+_vm._s(_vm.iconByInterval)+"\n    ")])]}}])},[_vm._v(" "),_c('span',[_vm._v("\n    "+_vm._s(_vm.$t('signal.satellite.connection', {'satellites': _vm.value}))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }